var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.118896,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#4750F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 10.7856V13.4523M16 10.7856V13.4523",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3344 31.9483V24.4193C21.3344 24.1637 21.1521 23.9563 20.9272 23.9563H19.4414M24.6674 25.4523C24.8434 24.0603 25.9634 23.9003 27.0834 23.9563C27.9634 23.9163 29.3233 23.9803 29.3393 25.9803C29.3233 28.0603 27.6754 27.9153 27.6754 27.9483C27.6754 27.9814 29.4033 27.9003 29.3393 29.9803C29.3233 31.8203 28.1234 32.0123 27.0034 31.9483C25.8834 32.0283 24.8434 31.7403 24.6674 30.4603",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 24.4432C11.334 18.6335 11.334 15.7286 13.0035 13.9237C14.673 12.1189 17.36 12.1189 22.734 12.1189H25.2673C30.6413 12.1189 33.3284 12.1189 34.9978 13.9237C36.6673 15.7286 36.6673 18.6335 36.6673 24.4432V25.128C36.6673 30.9377 36.6673 33.8425 34.9978 35.6474C33.3284 37.4522 30.6413 37.4522 25.2673 37.4522H22.734C17.36 37.4522 14.673 37.4522 13.0035 35.6474C11.334 33.8425 11.334 30.9377 11.334 25.128V24.4432Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.7856H32",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate13);
export default __webpack_public_path__ + "static/media/date13.c3a5180138d3b6a39b2be3e98d54fbcb.svg";
export { ForwardRef as ReactComponent };